export default __webpack_public_path__ + "static/media/chevron-icon-down.8ca749f6.svg";